export default "__VITE_ASSET__BRBQpKWo__"